<template>
    <div class="tax-declare-layout quick-declare-step-4">
        <div class="data-area">
            <ButtonSet @update:activeTab="onActiveTabUpdate">
                <template slot="action-right">
                    <el-button class="btn" type="highlight" size="" icon="el-icon-download" @click="onExportMediaFile">下載媒體檔</el-button>
                </template>
            </ButtonSet>
            <DataTable
                v-if="isTableMode"
                ref="DataTable"
                :showPeriod="true"
                :activeTab="activeTab"
                @onOpenInvoiceDetail="onOpenInvoiceDetail"
                @onOpenPaymentDetail="onOpenPaymentDetail"
                @onOpenTranInvoiceDetail="onOpenTranInvoiceDetail"
            />
            <div v-else class="media-file-preview">
                <div v-for="(row, index) in step4MediaFileData" :key="index" class="row-block">
                    <div class="index-label">{{ index + 1 }}</div>
                    <div class="row-label">{{ row }}</div>
                </div>
                <div class="row-block last">
                    <div class="index-label"></div>
                    <div class="row-label"></div>
                </div>
            </div>
        </div>
        <div class="side-area">
            <QuickDeclareQuerySidePanel>
                <!-- <el-button class="btn" type="primary" @click="onExportMediaFile">下載媒體檔</el-button> -->
            </QuickDeclareQuerySidePanel>
        </div>
        <DeclareOperationHintDialog :visible="DeclareOperationHintDialogVisible" @close="DeclareOperationHintDialogVisible = false" />
    </div>
</template>

<script>
import moment from 'moment';
import {
    mapMutations, mapState, mapGetters, mapActions,
} from 'vuex';
import ButtonSet from '@/components/dashboard/Accounting/BusinessTax/QuickDeclareSummaryButtonSet.vue';
import DataTable from '@/components/dashboard/Accounting/BusinessTax/DataTable.vue';
import QuickDeclareQuerySidePanel from '@/components/dashboard/Accounting/BusinessTax/QuickDeclareQuerySidePanel.vue';
import DeclareOperationHintDialog from '@/components/dashboard/Accounting/BusinessTax/DeclareOperationHintDialog.vue';

export default {
    components: {
        ButtonSet,
        DataTable,
        QuickDeclareQuerySidePanel,
        DeclareOperationHintDialog,
    },
    data() {
        return {
            DeclareOperationHintDialogVisible: false,
            activeTab: 'invoice',
        };
    },
    created() {
        this.updateQuery({
            SearchType: 1,
            QueryType: 1,
            TaxDeclareStatus: 1,
            period: this.declarePeriod,
            Foo: null,
            Bsn: null,
            Amt: null,
        });
        this.emptyData();
        this.updateDeclaredData();
    },
    computed: {
        ...mapState({
            declaredInvoiceItems: (state) => state.businessTax.declaredInvoiceItems,
            declaredPaymentItems: (state) => state.businessTax.declaredPaymentItems,

            declarePeriod: (state) => state.businessTax.declarePeriod,
            periodList: (state) => state.businessTax.periodList,

            isTableMode: (state) => state.businessTax.step4DisplayMode === 'Table',
            step4MediaFileData: (state) => state.businessTax.step4MediaFileData,
        }),
        ...mapGetters({
            companyInfo: 'menu/companyInfo',
        }),
        period: {
            get() {
                return this.declarePeriod;
            },
            set(val) {
                this.setDeclarePeriod(val);
            },
        },
    },
    methods: {
        ...mapMutations({
            setDeclarePeriod: 'businessTax/setDeclarePeriod',
            updateQuery: 'businessTax/updateQuery',
        }),
        ...mapActions({
            updateData: 'businessTax/updateData',
            updateDeclaredData: 'businessTax/updateDeclaredData',
            emptyData: 'businessTax/emptyData',
        }),
        onBackToTable() {
            this.updateQuery({
                period: this.declarePeriod,
                SearchType: 2,
                QueryType: 1,
                TaxDeclareStatus: 2,
                declarePeriod: this.declarePeriod,
            });
            this.$router.push({
                name: 'accounting-business-tax-summary',
            });
        },

        onOpenPaymentDetail(sno) {
            this.$emit('openPayment', sno);
        },
        onOpenInvoiceDetail(sno) {
            this.$emit('openInvoice', sno);
        },
        onOpenTranInvoiceDetail(tioo) {
            this.$emit('openTranInvoice', tioo);
        },
        async onExportMediaFile(protection) {
            this.isLoading = true;
            try {
                const target = [...this.declaredInvoiceItems, ...this.declaredPaymentItems];
                console.log(target);
                const isNotExportable = target.find((o) => !o.code || o.code === '0');
                if (protection && isNotExportable) {
                    this.$message({
                        showClose: true,
                        message: '尚有項目未設定格式代號',
                        type: 'error',
                    });
                    return;
                }
                const formatedTxt = this.getUploadFormat(target);
                this.DeclareOperationHintDialogVisible = true;
                this.onDownload(`${this.companyInfo.bsn || '無公司統編'}.txt`, formatedTxt);
            } finally {
                this.isLoading = false;
            }
        },
        getUploadFormat(items) {
            const row = [];
            items.forEach((item, i) => {
                const IS_INCOME = !!item.ioo || !!item.tioo;
                const IS_FILE_TYP_11 = !IS_INCOME && item.filE_TYP === 11;

                const CODE = item.code;
                const TAX_STATUS = this.getPaddingString(this.companyInfo.taX_BOO, 9);
                const SERIAL = this.getPaddingString(i + 1, 7);
                const DATE = this.getROCDateFormat(IS_INCOME && item.typ < 0 ? item.orI_FOO_DAT : item.foO_DAT);
                let BUYER_NUM = this.getPaddingString(IS_INCOME ? item.bsn || '        ' : this.companyInfo.bsn, 8);
                // eslint-disable-next-line eqeqeq
                const IS_TYPE_B = item.code == 22 || item.code == 32 || BUYER_NUM === '        ';
                const SELLER_NUM = this.getPaddingString(IS_INCOME ? this.companyInfo.bsn : item.bsn, 8);
                let INVOICE_NUM = item.foo;
                let TAXATION = IS_INCOME ? item.tax : 1;

                let TAX_AMT = this.getPaddingString(this.getUploadFormatTaxAmount(item), 10);
                const NON_TAX_AMT = item.amt - this.getUploadFormatTaxAmount(item);
                let BILL_AMT = this.getPaddingString(NON_TAX_AMT, 12);
                const DEDUCT_CODE = IS_INCOME ? ' ' : 1;

                // 作廢
                if (item.foO_CNL) {
                    TAXATION = 'F';
                    BUYER_NUM = '        ';
                    BILL_AMT = this.getPaddingString(0, 12);
                    TAX_AMT = this.getPaddingString(0, 10);
                }

                // 車票單據號碼
                if (IS_FILE_TYP_11) INVOICE_NUM = this.getReceiptFormatFoo(item.foo);

                // 二聯式或發票銷售額需填寫含稅金額
                if (IS_TYPE_B) {
                    BILL_AMT = this.getPaddingString(item.amt, 12);
                    TAX_AMT = this.getPaddingString(0, 10);
                }

                row.push(
                    // eslint-disable-next-line max-len
                    `${CODE}${TAX_STATUS}${SERIAL}${DATE}${BUYER_NUM}${SELLER_NUM}${INVOICE_NUM}${BILL_AMT}${TAXATION}${TAX_AMT}${DEDUCT_CODE}`,
                );
            });

            return row.join('\n');
        },
        getUploadFormatTaxAmount(item) {
            return item.typ === undefined ? item.tax : item.amT_TAX;
        },
        onDownload(filename, text) {
            const element = document.createElement('a');
            element.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`);
            element.setAttribute('download', filename);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
        },

        getPaddingString(num, paddingLength) {
            return `${num}`.padStart(paddingLength, '0');
        },
        getROCDateFormat(timestamp) {
            const TIME = moment(timestamp);
            return `${TIME.year() - 1911}${TIME.format('MM')}`;
        },
        getReceiptFormatFoo(foo) {
            const FOO = foo.replaceAll('-', '');
            if (FOO.length < 10) return this.getPaddingString(foo, 10);
            return FOO.substring(FOO.length - 10, FOO.length);
        },
        onActiveTabUpdate(tab) {
            this.activeTab = tab;
        },
    },
};
</script>
<style lang="scss" scoped>
.quick-declare-step-4 {
    .media-file-preview {
        width: 100%;
        max-height: 600px;
        height: 100%;
        overflow: auto;
        padding-top: 10px;
        .row-block {
            display: flex;
            &.header {
                height: 10px;
                margin-top: -10px;
            }
            &.last {
                height: 10px;
            }
        }
        .index-label {
            color: #bebebe;
            font-size: 12px;
            width: 50px;
            background-color: #f4f4f4;
            box-sizing: border-box;
            padding-left: 10px;
            margin-right: 10px;
        }
        .row-label {
            white-space: break-spaces;
            font-family: monospace;
        }
    }
}
</style>
